import styled from 'styled-components';
import PropTypes from 'prop-types';

const TextContainer = styled.div`
  color: ${props => props.color};
  font-weight: ${props => props.weight};
  font-size: ${props => props.size};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-align: ${props => props.align};
  line-height: ${props => props.lineHeight};
  display: ${props => (props.inlineBlock ? 'inline-block' : 'block')};
`;

TextContainer.propTypes = {
  inlineBlock: PropTypes.bool,
};

TextContainer.defaultProps = {
  inlineBlock: false,
};

export default TextContainer;
